export const inputFormItems = [
  { label: 'Full Name', name: 'fullname' },
  { label: 'Email', name: 'email' },
];
